import { Observable, Subject, BehaviorSubject, of } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Router } from '@angular/router';
import { SuppliersProperties, SupplierList, BaseSaleOrderPreporties, SupplierAccessCodeBaseData, SupplierAccessCodeProperties } from '../Models/SuppliersProperties';
import { ActiveCurrencies, ActiveTimeZones, AirTicketActiveRights, ActiveCardTypes, ActiveAirlines } from '../Models/ActiveClasses';
import { SuppliersService } from '../Services/suppliers.service';
import { NgForm } from '@angular/forms';
import { Component } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http'
import { isUndefined } from 'util';
import { Data } from 'popper.js';
import { CompanyMasterProperties } from '../Models/CompanyMasterProperties';
import { UrlRequest } from '../Models/AgencyMasterProperties';
import { SuppliersCurrency } from '../Models/OfflineBookingRequestProperties';
import { MessageService } from 'primeng/api';
declare var $;
@Component({
  selector: 'app-suppliers-add-edit',
  templateUrl: './suppliers-add-edit.component.html',
  styleUrls: ['./suppliers-add-edit.component.css']
})
/** SuppliersAddEdit component*/
export class SuppliersAddEditComponent {
  /** SuppliersAddEdit ctor */
  airlines$: Observable<ActiveAirlines[]>;
  airTicketRights$: Observable<AirTicketActiveRights[]>;
  timeZones$: Observable<ActiveTimeZones[]>;
  currency$: Observable<ActiveCurrencies[]>;
  cards$: Observable<ActiveCardTypes[]>;
  baseDataforBackOfficeSuppliers = new BaseSaleOrderPreporties();
  backOfficeSuppliers$: Observable<SupplierList[]>;
  /*  baseData = new SupplierAccessCodeBaseData();*/
  supplier = new SuppliersProperties();
  preSupplier = new SuppliersProperties();
  airDivShow: boolean = false;
  insurancearrived: boolean = false;
  visaDivShow: boolean = false;
  actionType: string = "";
  actionName: string = "";
  /*  accessCodeObj = new SupplierAccessCodeProperties();*/
  /*  accessCodeArray: SupplierAccessCodeProperties[]=[];*/
  //airlineRightsObj = new SupplierAccessCodesAirlineRightsProperties();
  /* airlineRightsArray = [];*/
  repriceTrue: boolean = false;
  repriceFalse: boolean = false;
  inProgress: boolean = false;
  companyMasterList: CompanyMasterProperties[] = [];
  constructor(private service: SuppliersService, public router: Router, private http: HttpClient, private messageService: MessageService) {
  }
  ngOnInit() {
    try {
      this.supplier = new SuppliersProperties();
      this.GetCompanyMaster();
      //20-jan-24
      this.GetSupplierCurrencies();
      //end
      setTimeout(() => {
        this.loadDiv();
      }, 1000)
    } catch (ex) { }
  }
  //20-jan-24
  suppliersCurrencyList: SuppliersCurrency[] = [];
  private GetSupplierCurrencies = (): void => {
    this.service.GetSupplierCurrencies().subscribe(data => {
      this.suppliersCurrencyList = data;
    });
  }
  //end
  GetCompanyMaster() {
    this.service.GetCompanyMaster().subscribe(data => {
      this.companyMasterList = data;

    })
  }
  loadBaseData() {
    try {
      this.service.getSupplierAccessCodeBaseData().subscribe((data: SupplierAccessCodeBaseData) => {
        /* this.baseData = data;*/
        let all = new ActiveAirlines();
      /*  this.airlines = data.airlinesList;*/
        all.airlineCode = "All";
        all.airlineID = 0;
        all.airlinePrefixCode = "All";
        data.airlinesList.splice(0, 0, all);
        this.airlines$ = of(data.airlinesList);
        this.airTicketRights$ = of(data.rightsList);
        // console.log(data.rightsList);
        this.timeZones$ = of(data.timesList);
        this.currency$ = of(data.currencyList);
        this.cards$ = of(data.cardList);
        this.service.getSuppliersBackOffice(1).subscribe((data2: BaseSaleOrderPreporties) => {
          this.backOfficeSuppliers$ = of(data2.suppliers);
        });
      });
    } catch (ex) { }
  }
  RepriceChangeSelection(e: any, i: number) {
    try {
      if (e.target.id == "repriceTrue") {
        this.supplier.accessCodeList[i].repriceFalse = false;
        this.supplier.accessCodeList[i].repriceTrue = true;
        this.supplier.accessCodeList[i].repriceBeforeIssuance = false;
      }
      else if (e.target.id == "repriceFalse") {
        this.supplier.accessCodeList[i].repriceFalse = true;
        this.supplier.accessCodeList[i].repriceTrue = false;
        this.supplier.accessCodeList[i].repriceBeforeIssuance = false;
      }
    } catch (ee) { }
  }
  CashSelection(i: number) {
    try {

      this.supplier.accessCodeList[i].isCredit = false;
      this.supplier.accessCodeList[i].settelmentId = 2;

    } catch (ee) { }
  }
  CreditSelection(i: number) {
    try {
      this.supplier.accessCodeList[i].isCash = false;
      this.supplier.accessCodeList[i].settelmentId = 1;
      this.supplier.accessCodeList[i].cardExpiryDate = "1900-01-01";
      this.supplier.accessCodeList[i].cardNumber = "";
      this.supplier.accessCodeList[i].cardType = 0;
      this.supplier.accessCodeList[i].pinNumber = "";
      this.supplier.accessCodeList[i].cVV = "";
      this.supplier.accessCodeList[i].amount = 0;
      this.supplier.accessCodeList[i].appliedOnAirline = [];

    } catch (ee) { }
  }
  Save() {
    try {
      if (this.supplier.providerCode == "" || this.supplier.providerCode == null || this.supplier.providerCode == undefined) {
        $("#lblerrormsg").show();
        document.getElementById("lblerrormsg").innerHTML = "Required Provider"
        $("#lblerrormsg").delay(5000).hide(1000);

        return;
      }
      if (this.supplier.supplierId == "" || this.supplier.supplierId == null) {
        this.supplier.creationUser = (Number(localStorage.getItem("UserId")));
        this.supplier.accessCodeList = this.supplier.accessCodeList;
        this.AddAirlineRights();
        this.supplier.accessCodeList = this.supplier.accessCodeList;
        for (let i = 0; i < this.supplier.accessCodeList.length; i++) {
          this.checkAirlineAllIsSelected(i);
          //for (let j = 0; j < this.supplier.accessCodeList[i].airlineRightsList.length; j++) {
          //  this.supplier.accessCodeList[i].airlineRightsList[j].creationUser = Number(localStorage.getItem("UserId"));
          //  this.supplier.accessCodeList[i].cardExpiryDate = this.supplier.accessCodeList[i].cardExpiryDate;

          //}
          //for (let j = 0; j <this.supplier.accessCodeList[i].ticketRightsId.length; j++) {

          //  if (this.supplier.accessCodeList[i].ticketRightsId[j] == 1) {
          //    this.supplier.accessCodeList[i].canBook = true;
          //    break;
          //  }
          //  else{
          //    this.supplier.accessCodeList[i].canBook = false;
          //  }
          //}

          //for (let j = 0; j <this.supplier.accessCodeList[i].ticketRightsId.length; j++) {

          //  if (this.supplier.accessCodeList[i].ticketRightsId[j] == 2) {
          //    this.supplier.accessCodeList[i].canIssue = true;
          //    break;
          //  }
          //  else{
          //    this.supplier.accessCodeList[i].canIssue = false;
          //  }
          //}
          //for (let j = 0; j <this.supplier.accessCodeList[i].ticketRightsId.length; j++) {

          //  if (this.supplier.accessCodeList[i].ticketRightsId[j] == 3) {
          //    this.supplier.accessCodeList[i].canVoid = true;
          //    break;
          //  }
          //  else{
          //    this.supplier.accessCodeList[i].canVoid = false;
          //  }
          //}
          //for (let j = 0; j <this.supplier.accessCodeList[i].ticketRightsId.length; j++) {

          //  if (this.supplier.accessCodeList[i].ticketRightsId[j] == 4) {
          //    this.supplier.accessCodeList[i].canRefund = true;
          //    break;
          //  }
          //  else{
          //    this.supplier.accessCodeList[i].canRefund = false;
          //  }
          //}
          //for (let j = 0; j <this.supplier.accessCodeList[i].ticketRightsId.length; j++) {

          //  if (this.supplier.accessCodeList[i].ticketRightsId[j] == 5) {
          //    this.supplier.accessCodeList[i].canExchange = true;
          //    break;
          //  }
          //  else{
          //    this.supplier.accessCodeList[i].canExchange = false;
          //  }
          //}
          //for (let j = 0; j <this.supplier.accessCodeList[i].ticketRightsId.length; j++) {

          //  if (this.supplier.accessCodeList[i].ticketRightsId[j] == 6) {
          //    this.supplier.accessCodeList[i].canSearch = true;
          //    break;
          //  }
          //  else{
          //    this.supplier.accessCodeList[i].canSearch = false;
          //  }
          //}

        }
        if (this.checkAccessCode() == false) {

          if (this.checkAirlinesLength()) {
            this.service.create(this.supplier).subscribe((data) => {
              //  this.inProgress = false;
              //   document.getElementById("overlay").style.display = "none";
              if (data == true) {
                $("#lblerrormsg").show();
                document.getElementById("lblerrormsg").innerHTML = "Saved...!"
                $("#lblerrormsg").delay(5000).hide(1000);
                this.router.navigateByUrl('/suppliersList');
              }
              else {
                $("#lblerrormsg").show();
                document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
                $("#lblerrormsg").delay(5000).hide(1000);
              }
            });
          }
          else {
            $("#lblerrormsg").show();
            document.getElementById("lblerrormsg").innerHTML = "Select Airlines."
            $("#lblerrormsg").delay(5000).hide(1000);
          }
        }
        else {
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Same Office Ids cannot exist."
          $("#lblerrormsg").delay(5000).hide(1000);

        }
      }
      else {

        this.supplier.modifyUser = (Number(localStorage.getItem("UserId")));
        this.supplier.accessCodeList = this.supplier.accessCodeList;
        for (let i = 0; i < this.supplier.accessCodeList.length; i++) {
          this.checkAirlineAllIsSelected(i);
          this.supplier.accessCodeList[i].modifyUser = (Number(localStorage.getItem("UserId")));
          this.supplier.accessCodeList[i].supplierId = this.supplier.supplierId;
          if (this.supplier.supplierTypeId == 1) {
            //for (let j = 0; j < this.supplier.accessCodeList[i].airlineRightsList.length; j++) {
            //  this.supplier.accessCodeList[i].airlineRightsList[j].modifyUser = Number(localStorage.getItem("UserId"));
            //}
            if (this.supplier.accessCodeList[i].airlines != null || (this.supplier.accessCodeList[i].airlines.length > 0 && this.supplier.accessCodeList[i].airlines.length != null)) {
              this.AddAirlineRights();

            }
            else {
              break;
            }
          }
        }
        for (let i = 0; i < this.supplier.accessCodeList.length; i++) {
          if (this.supplier.accessCodeList[i].settelmentId == 2) {
            //this.accessCodeObj.cardExpiryDate = "";
            //this.accessCodeObj.cardNumber = "";
            //this.accessCodeObj.cardType = 0;
            //this.accessCodeObj.pinNumber = "";
            //this.accessCodeObj.cVV = "";
            //this.accessCodeObj.amount = 0;
          }

          if (this.supplier.accessCodeList[i].airlines.length != null && this.supplier.accessCodeList[i].airlines.length > 0
            && this.supplier.accessCodeList[i].airlines.length != null && this.supplier.accessCodeList[i].airlines.length > 0) {
            //for (let j = 0; j < this.supplier.accessCodeList[i].airlineRightsList.length; j++) {
            //  this.supplier.accessCodeList[i].airlineRightsList[j] = this.supplier.accessCodeList[i].airlineRightsList[j];

            //}
          }
          //for (let j = 0; j <this.supplier.accessCodeList[i].ticketRightsId.length; j++) {

          //  if (this.supplier.accessCodeList[i].ticketRightsId[j] == 1) {
          //    this.supplier.accessCodeList[i].canBook = true;
          //    break;
          //  }
          //  else{
          //    this.supplier.accessCodeList[i].canBook = false;
          //  }
          //}

          //for (let j = 0; j <this.supplier.accessCodeList[i].ticketRightsId.length; j++) {

          //  if (this.supplier.accessCodeList[i].ticketRightsId[j] == 2) {
          //    this.supplier.accessCodeList[i].canIssue = true;
          //    break;
          //  }
          //  else{
          //    this.supplier.accessCodeList[i].canIssue = false;
          //  }
          //}
          //for (let j = 0; j <this.supplier.accessCodeList[i].ticketRightsId.length; j++) {

          //  if (this.supplier.accessCodeList[i].ticketRightsId[j] == 3) {
          //    this.supplier.accessCodeList[i].canVoid = true;
          //    break;
          //  }
          //  else{
          //    this.supplier.accessCodeList[i].canVoid = false;
          //  }
          //}
          //for (let j = 0; j <this.supplier.accessCodeList[i].ticketRightsId.length; j++) {

          //  if (this.supplier.accessCodeList[i].ticketRightsId[j] == 4) {
          //    this.supplier.accessCodeList[i].canRefund = true;
          //    break;
          //  }
          //  else{
          //    this.supplier.accessCodeList[i].canRefund = false;
          //  }
          //}
          //for (let j = 0; j <this.supplier.accessCodeList[i].ticketRightsId.length; j++) {

          //  if (this.supplier.accessCodeList[i].ticketRightsId[j] == 5) {
          //    this.supplier.accessCodeList[i].canExchange = true;
          //    break;
          //  }
          //  else{
          //    this.supplier.accessCodeList[i].canExchange = false;
          //  }
          //}
          //for (let j = 0; j <this.supplier.accessCodeList[i].ticketRightsId.length; j++) {

          //  if (this.supplier.accessCodeList[i].ticketRightsId[j] == 6) {
          //    this.supplier.accessCodeList[i].canSearch = true;
          //    break;
          //  }
          //  else{
          //    this.supplier.accessCodeList[i].canSearch = false;
          //  }
          //}
        }
        if (this.checkAccessCode() == false) {
          if (this.checkAirlinesLength()) {
            // console.log(this.supplier);
            this.service.update(this.supplier).subscribe((data) => {

              if (data == true) {
                $("#lblerrormsg").show();
                document.getElementById("lblerrormsg").innerHTML = "Saved...!"
                $("#lblerrormsg").delay(5000).hide(1000);
                this.router.navigateByUrl('/suppliersList');
              }
              else {
                $("#lblerrormsg").show();
                document.getElementById("lblerrormsg").innerHTML = "Something went wrong...!"
                $("#lblerrormsg").delay(5000).hide(1000);
              }
            });
          }
          else {
            $("#lblerrormsg").show();
            document.getElementById("lblerrormsg").innerHTML = "Select Airlines."
            $("#lblerrormsg").delay(5000).hide(1000);
          }
        }
        else {
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Same Office ids cannot exist."
          $("#lblerrormsg").delay(5000).hide(1000);

        }
      }

    } catch (ex) {

    }
  }
  checkAirlinesLength(): boolean {
    let valid = false;
    if (this.supplier.supplierTypeId == 1) {
      for (let i = 0; i < this.supplier.accessCodeList.length; i++) {

        if (this.supplier.accessCodeList[i].airlines.length > 0) {
          valid = true
        }
        else {
          valid = false;
          break;
        }
      }
    }
    else { valid = true; }
    return valid;
  }

  Cancel() {
    this.supplier = new SuppliersProperties();
    for (let i = 0; i < this.supplier.accessCodeList.length; i++) {
      this.supplier.accessCodeList = [];

    }
    this.AddAccessCode();
  }
  AddAccessCode() {
    try {
      let accessCodeObj = new SupplierAccessCodeProperties()
      accessCodeObj.creationUser = Number(localStorage.getItem("UserId"));
      accessCodeObj.excludedAirlines = [];

      if (this.insurancearrived) {
        accessCodeObj.backOfficeSupplierCode = "";
        accessCodeObj.companyId = 0;
        accessCodeObj.airlines = [];
        accessCodeObj.excludedAirlines = [];
      }
      this.supplier.accessCodeList.push(accessCodeObj);
    }
    catch (ex) {

    }
  }
  AddAirlineRights() {
    try {
      if (this.supplier.supplierTypeId == 1) {
        //for (let i = 0; i < this.supplier.accessCodeList.length; i++) {
        //  this.airlineRightsArray = [];
        //  //console.log(this.supplier.accessCodeList[i].airlines.length);
        //  //console.log(this.supplier.accessCodeList[i].airlines.length);
        //  if (this.supplier.accessCodeList[i].airlines.length != null && this.supplier.accessCodeList[i].airlines.length > 0
        //    && this.supplier.accessCodeList[i].airlines.length != null && this.supplier.accessCodeList[i].airlines.length > 0) {
        //    for (let j = 0; j < this.supplier.accessCodeList[i].airlines.length; j++) {
        //      this.airlineRightsObj = new SupplierAccessCodesAirlineRightsProperties();
        //      this.airlineRightsObj.airlineID = this.supplier.accessCodeList[i].airlines[j];
        //      this.airlineRightsObj.supplierAccessCodeId = this.supplier.accessCodeList[i].supplierAccessCodeId;
        //      this.airlineRightsObj.supplierAccessCodeAirlineRightsId = this.supplier.accessCodeList[i].supplierAcccessCodeAirlineRightsId;
        //      this.airlineRightsObj.creationUser = Number(localStorage.getItem('UserId'));
        //      this.airlineRightsArray.push(this.airlineRightsObj);
        //    }
        //    this.supplier.accessCodeList[i].airlineRightsList = this.airlineRightsArray;
        //  }
        //}

        for (let i = 0; i < this.supplier.accessCodeList.length; i++) {

          if (this.supplier.accessCodeList[i].airlines.length != null && this.supplier.accessCodeList[i].airlines.length > 0
            && this.supplier.accessCodeList[i].airlines.length != null && this.supplier.accessCodeList[i].airlines.length > 0) {
            //for (let k = 0; k < this.supplier.accessCodeList[i].airlineRightsList.length; k++) {

            //  for (let j = 0; j <this.baseData.rightsList.length; j++) {
            //    if (this.supplier.accessCodeList[i].ticketRightsId[j] == 1) {

            //      this.supplier.accessCodeList[i].airlineRightsList[k].canBook = true;

            //    }
            //    if (this.supplier.accessCodeList[i].ticketRightsId[j] == 2) {
            //      this.supplier.accessCodeList[i].airlineRightsList[k].canIssue = true;

            //    }
            //    if (this.supplier.accessCodeList[i].ticketRightsId[j] == 3) {
            //      this.supplier.accessCodeList[i].airlineRightsList[k].canVoid = true;

            //    }
            //    if (this.supplier.accessCodeList[i].ticketRightsId[j] == 4) {
            //      this.supplier.accessCodeList[i].airlineRightsList[k].canRefund = true;

            //    }
            //    if (this.supplier.accessCodeList[i].ticketRightsId[j] == 5) {
            //      this.supplier.accessCodeList[i].airlineRightsList[k].canExchange = true;

            //    }
            //    if (this.supplier.accessCodeList[i].ticketRightsId[j] == 6) {
            //      this.supplier.accessCodeList[i].airlineRightsList[k].canSearch = true;

            //    }
            //  }

            //  this.supplier.accessCodeList[i].airlineRightsList[k].branch = localStorage.getItem("AgencyId");
            //}
          }
        }
      }
    }
    catch (ex) {

    }
  }
  loadDiv() {
    try {
      if (localStorage.getItem("ActionType") != undefined && localStorage.getItem("ActionType") != null) {
        this.actionType = localStorage.getItem("ActionType");
        if (this.actionType == "AirOfficeAdd") {
          this.airDivShow = true;
          this.supplier.supplierTypeId = 1;
          this.visaDivShow = false;
          this.loadBaseData();
          let code = localStorage.getItem("SupplierId");
          this.service.getSupplierById(code).subscribe((data) => {
       
            this.supplier = data as SuppliersProperties;
     

            for (let i = 0; i < this.supplier.accessCodeList.length; i++) {
              if (this.supplier.accessCodeList[i].companyId != 0) {
                let companyURL = "";
                for (let j = 0; j < this.companyMasterList.length; j++) {
                  if (this.supplier.accessCodeList[i].companyId == this.companyMasterList[j].companyId) {
                    companyURL = this.companyMasterList[j].companyURL;

                    break;
                  }

                }

                var req = new UrlRequest();
                req.request = companyURL;
                this.service.GetSupplierCodeByID(req).subscribe((data) => {

                  this.supplier.accessCodeList[i].supplierCodesList = data



                });
              }
            }
            //console.log(this.supplier);
            this.preSupplier = this.supplier;
          });
        }
        else if (this.actionType == "AirOfficeEdit") {
          this.airDivShow = true;
          this.visaDivShow = false;
          let id = Number(localStorage.getItem("SupplierAccessCodeId"));
          this.service.getSupplierAccessCodeById(id).subscribe((data) => {
            this.supplier = data as SuppliersProperties;
            this.loadBaseData();
            //console.log(this.supplier);
          });
        }
        else if (this.actionType == "AirSupplierAdd" || this.actionType == "InsuranceSupplierAdd") {
          this.airDivShow = true;
          if (this.actionType == "AirSupplierAdd") {
            this.actionName = "Air";
  
            this.supplier.supplierTypeId = 1;
          }

          else if (this.actionType == "InsuranceSupplierAdd") {
            this.actionName = "Insurance";
            this.insurancearrived = true;
            this.supplier.supplierTypeId = 3;
          }
          this.visaDivShow = false;
          this.loadBaseData();
        }
        else if (this.actionType == "AirSupplierEdit" || this.actionType == "InsuranceSupplierEdit") {
          this.airDivShow = true;
          if (this.actionType == "AirSupplierEdit") {
            this.actionName = "Air";
            this.supplier.supplierTypeId = 1;
          }
          else if (this.actionType == "InsuranceSupplierEdit") {
            this.actionName = "Insurance";
            this.insurancearrived = true;
            this.supplier.supplierTypeId = 3;
          }
          this.visaDivShow = false;
          this.loadBaseData();
          let code = localStorage.getItem("SupplierId");
          this.service.getSupplierById(code).subscribe((data) => {
            this.supplier = data as SuppliersProperties;


            for (let i = 0; i < this.supplier.accessCodeList.length; i++) {
              if (this.supplier.accessCodeList[i].companyId != 0) {
                let companyURL = "";
                for (let j = 0; j < this.companyMasterList.length; j++) {
                  if (this.supplier.accessCodeList[i].companyId == this.companyMasterList[j].companyId) {
                    companyURL = this.companyMasterList[j].companyURL;

                    break;
                  }

                }

                var req = new UrlRequest();
                req.request = companyURL;
                this.service.GetSupplierCodeByID(req).subscribe((data) => {

                  this.supplier.accessCodeList[i].supplierCodesList = data



                });
              }
            }
            //console.log(this.supplier);
            this.supplier.accessCodeList = this.supplier.accessCodeList.map(item => {
              if (item.settelmentId === 2) {
                return { ...item, isCash: true, isCredit: false };
              } else if (item.settelmentId === 1) {
                return { ...item, isCash: false, isCredit: true };
              } else {
                return { ...item, isCash: false, isCredit: false };
              }
            });

            this.preSupplier = this.supplier;
          });
        }
        else if (this.actionType == "VisaOfficeAdd") {
          this.airDivShow = false;
          this.supplier.supplierTypeId = 2;
          this.visaDivShow = true;
          let code = localStorage.getItem("SupplierId");
          this.service.getSupplierById(code).subscribe((data) => {
            this.supplier = new SuppliersProperties();
            this.supplier.accessCodeList = [];
            this.supplier = data as SuppliersProperties;
            this.supplier.accessCodeList = data.accessCodeList;
            this.supplier.accessCodeList = [];
            for (let i = 0; i < this.supplier.accessCodeList.length; i++) {
              this.supplier.accessCodeList.push(this.supplier.accessCodeList[i]);
              this.supplier.accessCodeList[i].airlines = [];
              // this


              if (this.supplier.accessCodeList[i].repriceBeforeIssuance) {
                this.supplier.accessCodeList[i].repriceTrue = true;
                this.supplier.accessCodeList[i].repriceFalse = false;
              }
              else {
                this.supplier.accessCodeList[i].repriceTrue = false;
                this.supplier.accessCodeList[i].repriceFalse = true;
              }
              if (this.supplier.accessCodeList[i].settelmentId == 1) {
                this.supplier.accessCodeList[i].isCredit = true;
                this.supplier.accessCodeList[i].isCash = false;
                this.supplier.accessCodeList[i].cardExpiryDate = this.supplier.accessCodeList[i].cardExpiryDate.split('T')[0];
                // //console.log(this.supplier.accessCodeList[i].cardExpiryDate);
              }
              else if (this.supplier.accessCodeList[i].settelmentId == 2) {
                this.supplier.accessCodeList[i].isCredit = false;
                this.supplier.accessCodeList[i].isCash = true;
                this.supplier.accessCodeList[i].cardExpiryDate = "";
                this.supplier.accessCodeList[i].cardNumber = "";
                this.supplier.accessCodeList[i].cardType = 0;
                this.supplier.accessCodeList[i].pinNumber = "";
                this.supplier.accessCodeList[i].cVV = "";
                this.supplier.accessCodeList[i].amount = 0;
              }

            }
            this.loadBaseData();
          });
          //  //console.log(this.supplier);
        }
        else if (this.actionType == "VisaOfficeEdit") {
          this.airDivShow = false;
          this.visaDivShow = true;
          let id = Number(localStorage.getItem("SupplierAccessCodeId"));
          this.service.getSupplierAccessCodeById(id).subscribe((data) => {
            this.supplier = new SuppliersProperties();
            this.supplier.accessCodeList = [];
            this.supplier = data as SuppliersProperties;
            this.supplier.accessCodeList = [];
            this.loadBaseData();
            for (let i = 0; i < this.supplier.accessCodeList.length; i++) {
              this.supplier.accessCodeList[i].airlines = [];
              this.supplier.accessCodeList.push(this.supplier.accessCodeList[i]);
              if (this.supplier.accessCodeList[i].repriceBeforeIssuance) {
                this.supplier.accessCodeList[i].repriceTrue = true;
                this.supplier.accessCodeList[i].repriceFalse = false;
              }
              else {

                this.supplier.accessCodeList[i].repriceTrue = false;
                this.supplier.accessCodeList[i].repriceFalse = true;
              }
              if (this.supplier.accessCodeList[i].settelmentId == 1) {
                this.supplier.accessCodeList[i].isCredit = true;
                this.supplier.accessCodeList[i].isCash = false;
                this.supplier.accessCodeList[i].cardExpiryDate = this.supplier.accessCodeList[i].cardExpiryDate.split('T')[0];
                // //console.log(this.supplier.accessCodeList[i].cardExpiryDate);
              }
              else if (this.supplier.accessCodeList[i].settelmentId == 2) {
                this.supplier.accessCodeList[i].isCredit = false;
                this.supplier.accessCodeList[i].isCash = true;
                this.supplier.accessCodeList[i].cardExpiryDate = "";
                this.supplier.accessCodeList[i].cardNumber = "";
                this.supplier.accessCodeList[i].cardType = 0;
                this.supplier.accessCodeList[i].pinNumber = "";
                this.supplier.accessCodeList[i].cVV = "";
                this.supplier.accessCodeList[i].amount = 0;
              }
            }
          });
        }
        else if (this.actionType == "VisaSupplierAdd") {
          this.airDivShow = false;
          this.supplier.supplierTypeId = 2;
          this.visaDivShow = true;
          this.loadBaseData();
        }
      }
    }
    catch (ex) {
      //console.log(ex);
    }
  }
  //checkAirlineAllIsSelected(i:number) {
  //  let airlineslist: string[] = this.supplier.accessCodeList[i].airlines;
  //  let checkall = airlineslist.find(ft => ft == "All");
  //  if (checkall && airlineslist.length > 1) {
  //    this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'If You Selected All then no multiple is allowed to add.' });
  //    return;
  //  }
  //}
  checkAirlineAllIsSelected(i: number): void {
    const selected = this.supplier.accessCodeList[i].airlines;
    const allSelected = selected.includes('All');

    if (allSelected) {
      this.supplier.accessCodeList[i].airlines = ['All'];
    } else {
      this.supplier.accessCodeList[i].airlines = selected.filter(a => a !== 'All');
    }
  }
  checkexcludedAirlineAllIsSelected(i: number): void {
    const selected = this.supplier.accessCodeList[i].excludedAirlines;
    const allSelected = selected.includes('All');

    if (allSelected) {
      this.supplier.accessCodeList[i].excludedAirlines = ['All'];
    } else {
      this.supplier.accessCodeList[i].excludedAirlines = selected.filter(a => a !== 'All');
    }
  }
  checkAccessCode(): boolean {
    let isSame = false;
    var valueArr = this.supplier.accessCodeList.map(function (item) { return item.accessCode });
    isSame = valueArr.some(function (item, idx) {
      return valueArr.indexOf(item) != idx
    });

    return isSame;
  }
  checkSupplierName(e: any) {
    this.inProgress = true;
    document.getElementById("overlay").style.display = "block";
    //let name = e.target.value;
    if (this.airDivShow) {
      $("#btnSaveAir").attr("disabled", "disabled")
      this.supplier.name = e.target.value;;
      this.supplier.supplierTypeId = 1;
      this.service.checkSupplierName(this.supplier).subscribe((data) => {
        if (data == true) {
          this.inProgress = false;
          document.getElementById("overlay").style.display = "none";
          //if (this.airDivShow) {
          document.getElementById("lblNameAir").innerHTML = "SupplierName already exist.";
          $(document.getElementById("lblNameAir")).show();
          $(document.getElementById("lblNameAir")).delay(5000).hide(1000);
          // }
        }
        else {
          this.inProgress = false;
          document.getElementById("overlay").style.display = "none";
          $("#btnSaveAir").removeAttr("disabled", "disabled");
        }

      })
    }
    else if (this.visaDivShow) {
      $("#btnSaveVisa").attr("disabled", "disabled")
      this.supplier.name = e.target.value;
      this.supplier.supplierTypeId = 2;
      this.service.checkSupplierName(this.supplier).subscribe((data) => {
        if (data == true) {
          this.inProgress = false;
          document.getElementById("overlay").style.display = "none";
          // if (this.visaDivShow) {
          document.getElementById("lblNameVisa").innerHTML = "SupplierName already exist.";
          $(document.getElementById("lblNameVisa")).show();
          $(document.getElementById("lblNameVisa")).delay(5000).hide(1000);
          //}
        }
        else {
          this.inProgress = false;
          document.getElementById("overlay").style.display = "none";
          $("#btnSaveVisa").removeAttr("disabled", "disabled");
        }

      })

    }
  }

  public ParseDate = (dateString: string): string => {
    if (dateString) {
      return dateString;
    }
    return null;
  }
  ExpiryDateValidation(date) {

    ////console.log(date.split('T')[0]);*9+
    let nowdate = new Date();
    let datechek = new Date(date);
    if (datechek < nowdate) {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Expired Card Please Use Correct Card!!' });

      }
  }
  checkforAllAirlines(i): boolean {
    let isAll = false;
    for (let j = 0; j < this.supplier.accessCodeList[i].airlines.length; j++) {
      if (this.supplier.accessCodeList[i].airlines[j] == "All") {
        isAll = true;
        break;
      }
    }
    if (isAll) {
      this.supplier.accessCodeList[i].airlines = [];
      let all = new ActiveAirlines();
      //this.airlines = data.airlinesList;
      all.airlineCode = "All";
      this.supplier.accessCodeList[i].airlines.push("All");
    }
    return isAll;
  }
  GetBackSystemSupplier = (companyId: number, index): void => {

    if (companyId != 0 && companyId != null && companyId != undefined) {
      let companyURL = "";
      for (let i = 0; i < this.companyMasterList.length; i++) {
        if (companyId == this.companyMasterList[i].companyId) {
          companyURL = this.companyMasterList[i].companyURL;
          break;
        }

      }
      var req = new UrlRequest();
      req.request = companyURL;
      this.service.GetSupplierCodeByID(req).subscribe((data) => {
        this.supplier.accessCodeList[index].supplierCodesList = data

      });

    }


  }
  loader: boolean = false;
  onsubmitform: boolean = false;
  onSubmit(form: NgForm) {
    console.log(form);
    if (form.valid) {
      this.loader = true;
      if (this.supplier.supplierId == "" || this.supplier.supplierId == null || this.supplier.supplierId == undefined) {
        this.service.create(this.supplier).subscribe((data) => {
          //  this.inProgress = false;
          //   document.getElementById("overlay").style.display = "none";
          this.loader = false;
          if (data == true) {

            this.router.navigateByUrl('/suppliersList');
          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Not Saved!' });

          }
        });

      }
      else {
        this.service.update(this.supplier).subscribe((data) => {
          this.loader = false;
          if (data == true) {

            this.router.navigateByUrl('/suppliersList');
          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Not Updated!' });
          }
        });

      }


    }
    else {
      this.onsubmitform = true;
    }
  }
}
